import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Stack from '@mui/material/Stack'
import defaultTexts from '../../texts/texts'
import constants from '../../config/constants'
import useWindowDimensions from '../_common/WindowDimesnions'
import home_banner_top from '../../assets/images/home_banner_top.png'
import home_banner_top_logo from '../../assets/images/home_banner_top_logo.png'
import openstack_image from '../../assets/images/openstack_image.png'
import isender_image from '../../assets/images/isender_image.png'
import parse from 'html-react-parser'

const HomeContent = () => {
  const theme = useTheme()
  const { width } = useWindowDimensions()
  const navigate = useNavigate()

  const bannerTopStyle = {
    minHeight: '378px',
    background: `url(${home_banner_top}) no-repeat center / cover`,
    padding: width >= constants.smBreakpoint ? '0px 5%' : '20px',
    color: 'white',
  }

  const bannerTopTextStyle = {    
    fontSize: '40px',
    wordWrap: 'break-word'
  }

  const openStackWrapperStyle = {
    minHeight: '600px',
    background: theme.palette.aliceBlue,
    padding: '50px 20px',
  }

  const iSenderWrapperStyle = {
    minHeight: '600px',
    background: 'white',
    padding: '50px 20px',
  }

  const openStackUiLabel = {
    color: theme.palette.violetsAreBlue,
    paddingBottom: '30px',
    fontWeight: '500',
    fontSize: '32px',
  }

  const openStackUiDescription = {
    fontSize: '20px',
    paddingBottom: '30px',
  }

  const learnMoreStyle = {
    fontWeight: '500',
    color: theme.palette.denimBlue,
    fontSize: '24px',
    textDecoration: 'underline',
    cursor: 'pointer',

    '&:hover': {
      textDecoration: 'none',
    },
  }

  const imageStyle = {
    maxWidth: '100%',
    height: 'auto',
  }

  const handleNavigateToOpenStack = () => {
    navigate('/products/openstack-solution-kit')
  }

  const handleNavigateToISender = () => {
    navigate('/products/isender')
  }
  
  return (
    <>
      <Box sx={bannerTopStyle}>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, sm: 8, md: 6, lg: 5, xl: 4 }}>
            <Box>
              <Stack
                direction='column'
                alignItems='flex-start'
                justifyContent='space-evenly'
                sx={{ minHeight: width >= constants.smBreakpoint ? '378px' : 'initial' }}
              >
                <Box>
                  <img src={home_banner_top_logo} alt='' />
                </Box>
                <Box sx={bannerTopTextStyle}>
                  {parse(defaultTexts.homeBannerTopText)}
                </Box>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box sx={openStackWrapperStyle}>
        <Grid container spacing={ width >= constants.lgBreakpoint ? 12 : 4 }>
          <Grid size={{ xs: 12, lg: 7, xl: 7 }} offset={{ xs: 0, xl: 1 }}>
            <Box>
              <Stack
                direction='column'
                alignItems='flex-start'
                justifyContent='center'
                sx={{ minHeight: width >= constants.lgBreakpoint ? '500px' : 'initial' }}
              >
                <Box sx={openStackUiLabel}>{defaultTexts.openStackSolutionKit}</Box>
                <Box sx={openStackUiDescription}>{parse(defaultTexts.openStackSolutionKitProductDescription)}</Box>
                <Box sx={learnMoreStyle} onClick={handleNavigateToOpenStack}>{defaultTexts.learnMore}</Box>
              </Stack>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, lg: 5, xl: 4 }}>
            <Box>
              <Stack
                direction='column'
                alignItems={{ xs: 'center', lg: 'flex-start' }}
                justifyContent='center'
                sx={{ minHeight: width >= constants.lgBreakpoint ? '500px' : 'initial' }}
              >
                <Box>
                  <img src={openstack_image} alt='' style={imageStyle} />
                </Box>
              </Stack>              
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box sx={iSenderWrapperStyle}>
        <Grid container spacing={ width >= constants.lgBreakpoint ? 12 : 4 }>
          <Grid size={{ xs: 12, lg: 7, xl: 7 }} offset={{ xs: 0, xl: 1 }}>
            <Box>
              <Stack
                direction='column'
                alignItems='flex-start'
                justifyContent='center'
                sx={{ minHeight: width >= constants.lgBreakpoint ? '500px' : 'initial' }}
              >
                <Box sx={openStackUiLabel}>{defaultTexts.iSenderApplication}</Box>
                <Box sx={openStackUiDescription}>{parse(defaultTexts.iSenderApplicationProductDescription)}</Box>
                <Box sx={learnMoreStyle} onClick={handleNavigateToISender}>{defaultTexts.learnMore}</Box>
              </Stack>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, lg: 5, xl: 4 }}>
            <Box>
              <Stack
                direction='column'
                alignItems={{ xs: 'center', lg: 'flex-start' }}
                justifyContent='center'
                sx={{ minHeight: width >= constants.lgBreakpoint ? '500px' : 'initial' }}
              >
                <Box>
                  <img src={isender_image} alt='' style={imageStyle} />
                </Box>
              </Stack>              
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default HomeContent